import React, { useState, useEffect } from "react";
import styles from "./studentWorld.module.scss";
import PlacementSupportBanner from "../../assets/images/PlacementSupportBanner.png";
import StudentPlacementBanner from "../../assets/images/StudentPlacementBanner.jpg";
import WorkShopBanner from "../../assets/images/WorkShopBanner.jpg";
import InfoCard from "../CustomComponent/InfoCard.tsx";
import careerDevelopment from "../../assets/images/careerDevelopment.jpg";
import GlobalCarousel from "../CustomComponent/CustomCarousel.tsx";
import ImageTextSection from "../CustomComponent/ImageTextSection.tsx";
import BreadCrumb from "../CommonComponents/BreadCrumb.tsx";
import portfolioImg from "../../assets/images/portfolioImg.png";


const items: string[] = [
  "Resume building workshops ",
  "Mock interviews sessions ",
  "Soft skills training for improved professional communication ",
  "Interview scheduling with top recruiters from chosen fields. ",
];
const infoCardsData = [
  { text: "Workshops", icon: "workShop" },
  { text: "Industrial Tours", icon: "building" },
  { text: "Educational Events", icon: "calendarIcon" },
  { text: "Program Specific Seminars", icon: "videoCall" },
];
const breadcrumb = [
  { title: "Home", link: "/" },
  { title: "Student World", link: "/students-world" },
  { title: "Placements at Aptech", link: "" },
];
interface imageGroups {
  text: string;
  imgSrc: string;
}

const Placement: React.FC = () => {
  return (
    <div
      id="StudentPlacement"
      className={`${styles.studentPlacement} ${styles.partners}`}
    >
      <BreadCrumb menu={breadcrumb} />
      <PlacementBanner />
      <PlacementListView />
      <WorkshopSection />
    </div>
  );
};

const PlacementBanner = () => {
  const content = [
    `At Aptech, we are committed to not only provide vocational training programs to our students, but also to ensure they achieve their career goals. The dedicated placement cell at Aptech guides students from learning to landing their dream jobs in industries such as animation, VFX, IT, finance, aviation, hospitality, beauty and wellness, and wellness. `,
    `Working closely with mentors across all Aptech brands, the placement cell offers <strong>personalized guidance to help students build strong, industry-relevant portfolios</strong> that effectively showcase their skills and creativity. To ensure students are industry-ready, the placement cell organizes <strong>mock interview sessions, resume-building workshops, and professional grooming classes</strong>, equipping them with the expertise needed to excel in today’s job market. `
  ];
  return (
    <div className="container mt-5">
      <div className={`${styles.mainBannerDiv} section`}>
        <ImageTextSection
          imageSrc={StudentPlacementBanner}
          imageAlt="StudentPlacementBanner Image"
          content={content}
          heading="Placements at Aptech"
          reverse={true}
          imageHeight="450px"
          imageHeightMobile="300px"
          imageHeightTablet="400px"
        />
      </div>
    </div>
  );
};

const PlacementListView = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1080);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1080);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div className={styles.placementSupportDiv}>
      {!isMobile && (
        <div className={`row g-0 mt-0 `}>
          <div className="col-lg-3 col-md-12 col-sm-12"></div>
          <div
            className={`${styles.listDiv} col-lg-9 col-md-12 col-sm-12 d-flex flex-column justify-content-center`}
          >
            <p className="heading">PLACEMENT SUPPORT</p>
          </div>
        </div>
      )}
      <div className={`${styles.contentDiv}`}>
        <div className={`${styles.contentDiv} row g-0`}>
          {isMobile && (
            <div className={styles.listDiv}>
              <p className="heading">PLACEMENT SUPPORT</p>
            </div>
          )}

          <div
            className={`${styles.partnerImageDiv} col-lg-3 col-md-12 col-sm-12 position-relative`}
          >
            <img
              src={PlacementSupportBanner}
              alt="AptechImage"
              className={`${styles.partnerImage} img-fluid`}
            />
          </div>

          <div
            className={`${styles.listDivInfo} col-lg-9 col-md-12 col-sm-12 d-flex flex-column justify-content-center content contentTabView mb-3`}
          >
            <p className={`${styles.para} para mt-4 `}>
              The dedicated placement cell at Aptech offers end-to-to-end
              placement support to students throughout the recruitment process.
              From resume building to mock interview sessions and career
              counselling, the placement cell ensures that students are fully
              prepared to excel in the professional world.  
            </p>
            <p className={`${styles.para} para `}>
              As a part of the Placement Support at Aptech, students are
              benefitted from: 
            </p>
            <ul className="para">
              {items.map((item, index) => (
                <li className={`${styles.placementList}`} key={index}>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
const WorkshopSection = () => {
  const imageGroups: imageGroups[][] = [
    [
      { imgSrc: "", text: "Accenture" },
      { imgSrc: "", text: "Amazon" },
      { imgSrc: "", text: "Celebi" },
      { imgSrc: "", text: "Indigo" },
      { imgSrc: "", text: "Indira Gandhi International Airport" },
      { imgSrc: "", text: "Lakshya" },
      { imgSrc: "", text: "DNEG" },
      { imgSrc: "", text: "Red Chillies Entertainment " },
      { imgSrc: "", text: "Minimalist" },
      { imgSrc: "", text: "Lakmē Salon " },
      { imgSrc: "", text: "Enrich" },
      { imgSrc: "", text: "VLCC" },
      { imgSrc: "", text: "Aditya Birla Fashion and Retails " },
      { imgSrc: "", text: "Nykaa" },
      { imgSrc: "", text: "M.A.C " },
    ],
  ];
  const [activeIndex, setActiveIndex] = useState(0);

  const handleIndicatorClick = (index: number) => {
    setActiveIndex(index);
  };
  return (
    <div className="section position-relative">
      <div className="row g-0">
        <div className="col-lg-12 col-sm-12 col-md-12">
          <img
            src={WorkShopBanner}
            alt="WorkShopBannerImage"
            className={`${"w-100"}`}
          />
        </div>
      </div>
      <div className="container">
        <div className="">
          <div className="row g-0 position-relative">
            <div
              className={`col-lg-6 col-sm-12 col-md-12 ${styles.workShopDiv}`}
            >
              <div className="p-2">
                <p className="heading">Workshops and Mock interviews</p>
                <p className={`${styles.workShopPara} para`}>
                  Aptech’s Placement Cell conducts industry-relevant workshops
                  to help students enhance their:
                </p>
                <ul className={`${styles.workShopList} para`}>
                  <li>
                    technical skills in new-age tools and software used in
                    fields like animation, IT, and aviation operations
                  </li>
                  <li>soft skills, like communication and teamwork</li>
                  <li>
                    knowledge of emerging technologies like AI and machine
                    learning.
                  </li>
                </ul>
              </div>
            </div>

            <div
              className={`col-lg-6 col-md-12 col-sm-12 ${styles.workshopContent}`}
            >
              <p className="para">
                All of these bridge the gap between theory and practice,
                providing students at Aptech with real-world applications of
                their knowledge.
              </p>
              <p className="para">
                They also organise personalised mock interview sessions as a
                part of Aptech career courses. Students are provided with
                realistic interview scenarios to understand how real job
                interviews look like. Constructive and personalised feedback on
                mock interviews help them{" "}
                <strong>
                  understand their areas of improvement, sharpen their skills,
                </strong>{" "}
                and <strong>reduce interview anxiety.</strong>
              </p>
            </div>
          </div>
        </div>


        {/* New portfolio section */}
        <div className={`${styles.portfolioDiv} mt-5`}>
          <div className="position-relative">
      <div className="row">
        <div className="col-lg-6 col-sm-12">
          <div className="">
            <img
              src={portfolioImg}
              alt="AptechImage"
              className={`${styles.educationImg} img-fluid w-100`}
            />
            
          </div>
        </div>
        <div className="col-lg-6 col-sm-12">
        <p className="heading">
        Portfolio Development Sessions                 </p>
          <p className={`para ${styles.portfolioConetnt}`}>A strong and well-crafted portfolio is a key to unlocking exciting career opportunities. Our <strong>Portfolio Development Sessions</strong> are designed to help students showcase their <strong>skills, and creativity</strong> effectively to potential employers.</p>

          <div
              className={`d-flex justify-content-end ${styles.EducationsBenefitsOuterDiv}`}
            >
              <div className={styles.EducationsBenefitsInnerDiv}>
               
                <p className="para mb-0 p-3">
                The major highlights of the sessions are: 
                    <ul className={styles.benefitslist}>
                      <li>One-on-one mentorship to curate portfolios that highlight students’ <strong>unique strengths and achievements</strong>.</li>
                      <li>
                      Special emphasis on incorporating industry-relevant projects, case studies, and assignments.                      </li>
                      <li>Expert guidance on <strong>portfolio structuring & presentation</strong> like content placement, adding impactful descriptions, and creating a visually appealing layout.</li>
                      <li>Provide <strong>constructive feedback</strong> through portfolio review sessions.</li>
                      <li className="mb-0">Train students to present technical and creative skills effectively, be it animation, VFX, coding projects, or design prototypes.</li>
                    </ul>
                </p>
              </div>
            </div>
        </div>
       
      </div>
     
      </div>

      
    </div>

        <div className="section">
          <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12">
              <p className="heading mb-md-3">Career Development Training</p>
              <div className={`${styles.CDTParaDiv} para`}>
                <p className={`${styles.CDTPara} para`}>
                  Career development is an ongoing process at Aptech,
                  irrespective of the program chosen. 
                </p>
                <p className={`${styles.CDTPara} para`}>
                  Some of the major components of Aptech’s Career Development
                  Training include: 
                </p>
              </div>
              <div className="row">
                {infoCardsData.map((content, index) => (
                  <div className="col-lg-6 col-md-6 col-sm-12" key={index}>
                    <InfoCard
                      text={content.text}
                      icon={content?.icon}
                      height="90%"
                    />
                  </div>
                ))}
              </div>

              <p className="para mt-md-3">
                These career development activities, as a part of vocational
                training programs at Aptech ensure that students are well-versed
                in their subject matter and equipped with the skills necessary
                to thrive in their workplaces.
              </p>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 d-flex justify-content-center mt-md-4">
              <img
                src={careerDevelopment}
                alt="careerDevelopmentImage"
                className={`${styles.careerImg} img-fluid`}
              />
            </div>
          </div>
        </div>
        <div className={`${styles.placementPartners} section`}>
          <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12">
              <p className="heading">Placement Partners</p>
              <p className={`${styles.placementText} para me-lg-5  mt-md-3`}>
                Aptech has partnered with leading companies to ensure that
                students have access to diverse career paths. Some of our
                prominent placement partners include: 
              </p>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 d-flex justify-content-center align-items-center">
              <GlobalCarousel
                imageGroups={imageGroups}
                activeIndex={activeIndex}
                handleIndicatorClick={handleIndicatorClick}
                cols={4}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Placement;
